/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Metadata_TitleInputs */

const en_common_metadata_title = /** @type {(inputs: Common_Metadata_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`WordCraft: Free Online Editor, Downloads & Guides`)
};

/**
* | output |
* | --- |
* | "WordCraft: Free Online Editor, Downloads & Guides" |
*
* @param {Common_Metadata_TitleInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const common_metadata_title = /** @type {((inputs?: Common_Metadata_TitleInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Metadata_TitleInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_common_metadata_title(inputs)
});
export { common_metadata_title as "common.metadata.title" }